<template>
    <el-dialog
        title="批量设置SKU图"
        :visible.sync="dialogVisible"
        width="500px"
    >
        <div class="flex">
            <span>SKU规格图：</span>
            <ImgUpload
                ref="skuPicture"
                :width="80"
                :height="80"
                :limitWidth="[0,0]"
                :limitHeight="[0,0]"
                :aspectRatio="1"
                aspectRatioText="1:1"
                :limitSize="5 * 1024 * 1024"
                limitSuffix=".jpg,.jpeg,.png"
                :isSingle="true"
                :file="url"
                @upload-success="handleSkuPictureUpload"
                @del="handleSkuPictureDel"
                @handleLoad="handleLoad"
            />
        </div>
        <div class="mt-10" style="color:red;" v-if="errMsg">{{errMsg}}</div>
        <div class="mt-10" style="color:#999;">图片大小不超过5M，比例1:1，仅支持jpeg、jpg、png格式</div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload.vue';
export default {
    provide:{
        elFormItem:true, // ImgUpload 组件内部使用了elFormItem字段，防止报错所以加一下
    },
    model:{
        prop:'visible',
        event: 'change'
    },
    props:{
        visible:{
            type:Boolean,
            default:false
        }
    },
    components:{
        ImgUpload
    },
    data(){
        return {
            dialogVisible:false,
            url:'',
            errMsg:'',
        }
    },
    watch:{
        visible:{
            handler(v){
                this.dialogVisible = v
            },
            immediate:true
        },
        dialogVisible:{
            handler(v){
                if(v){
                    this.url = ''
                    this.errMsg = ''
                }
                this.$emit('change',v)
            }
        }
    },
    methods:{
        async confirm(){
            if(!this.url){
                this.$message.error('请上传图片！')
                return
            }
            if(await this.validImage()){
                return
            }
            // const errMsg = await this.$refs.skuPicture.method_validImage();
            // if(errMsg){
            //     this.errMsg = errMsg
            //     return
            // }
            this.$emit('confirm',this.url)
        },
        handleSkuPictureUpload(url){
            this.url = url
        },
        handleSkuPictureDel(){
            this.errMsg = ''
        },
        handleLoad(){
            this.validImage()
        },
        async validImage(){
            const errMsg = await this.$refs.skuPicture.method_validImage();
            this.errMsg = errMsg || ''
            return errMsg
        }
    }
}
</script>

<style lang="scss" scope>

</style>